/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useState, useRef, useMemo, useCallback } from 'react';
import { ARMcontext } from '../../../utils/context/context';
import { useSort } from '../../../utils/hooks/useSort';
import { FluidContainer, TableKeyMetrics, Loader, Modal, Radio } from '../../../components';
import {
  RadiosContainer,
  TableWrapper,
  RadiosWrapper,
  ArmRecoveryContainer,
  TextContainer,
  AlertContainer,
  AlertWrapper,
  Oval,
  ExamInfoContainer,
  ExamRadios,
  ArmRecoveryInfoButton,
  ArmRecoveryTop,
} from '../styles';
import { Teams } from '../../../utils/api';
import { ModalTop, ModalDivArrow, ModalTopText, ModalH1, ModalSpan, ModalBottom, ModalBottomLabels, ModalDots, Dot } from './styles';
import { TableHead, TableTopHeader, TableUnit, TableRow, TableSubHeader, TableColumn, TableBody } from '../../../components/Table/styles';
import { ArmRecovery, ArmFatigue, ArmStrength, ShoulderBalance, StrengthVelocityRatio } from '../../../utils/constants/fatigueZonesInfo';
import { capitalizeFirstLetters } from '../../../utils/hooks/text-formatter';
import TableKeyMetricsFatigue from '../../../components/Table/TableKeyMetricsFatigue';
import PaginationControls from '../../../components/PaginationControls/PaginationControls';
import { useKeyMetrics } from '../../../utils/hooks/keyMetrics.hook';
import { useLocation, useNavigate } from 'react-router-dom';

const useDelayedLoading = (loading, delay = 500) => {
  const [delayedLoading, setDelayedLoading] = useState(true);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (loading) {
      timerRef.current = setTimeout(() => setDelayedLoading(true), delay);
    } else {
      if (timerRef.current) clearTimeout(timerRef.current);
      setDelayedLoading(false);
    }

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [loading, delay]);

  return delayedLoading;
};

const KeyMetrics = ({
  keyScaleModal,
  setKeyScaleModal,
  playersGroup,
  playerNameSearch,
}: {
  isFirstLoad: boolean;
  keyScaleModal: boolean;
  setKeyScaleModal: any;
  playersGroup: any;
  playerNameSearch: string,
}) => {
  let location = useLocation();
  const navigate = useNavigate();
  const { pathname: path } = useMemo(()=>{return location}, [location]);
  let initialExam = { strength: true, fatigue: false };

  if (path.includes('fatigue')) {
    initialExam = { strength: false, fatigue: true };
  }
  const [radioExams, setRadioExams] = useState<any>(initialExam);
  const fatigueZones = [ArmStrength, ShoulderBalance, StrengthVelocityRatio, ArmRecovery, ArmFatigue];
  const { selectedTeam, triggerRefresh, setTriggerRefresh } = useContext(ARMcontext);
  const { sortBy, sortOrder, handleSort } = useSort('date', 'desc');

  const {
    keyMetricsStrength,
    keyMetricsFatigue,
    loadingTableStrength,
    loadingTableFatigue,
    paginationStrength,
    paginationFatigue,
    updatePaginationStrength,
    updatePaginationFatigue,
    fetchKeyMetrics,
  } = useKeyMetrics(selectedTeam, playersGroup, sortBy, sortOrder, playerNameSearch);
  const delayedLoadingStrength = useDelayedLoading(loadingTableStrength);
  const delayedLoadingFatigue = useDelayedLoading(loadingTableFatigue);
  const [modalPage, setModalPage] = useState<number>(1);
  const [modalInfo, setModalInfo] = useState<any>(ArmStrength);
  const TEAMS = new Teams();

  useEffect(() => {
    if (radioExams.strength) setModalPage(1)
    else setModalPage(5)
  }, []);

  const callTriggerFetchKeyMetric = async () => {
    await fetchKeyMetrics();
    setTriggerRefresh({
      ...triggerRefresh,
      keyMetric: false,
    });
  }

  useEffect(()=>{
    if(triggerRefresh.keyMetric)
      callTriggerFetchKeyMetric()
  }, [triggerRefresh.keyMetric])

  useEffect(() => {
    const loc = location.pathname;
    const word = 'keyMetrics';
    if (loc.substring(loc.length - word.length, loc.length) === word) {
      navigate('/players/keyMetrics/strength', { replace: true });
    }
  }, []);

  useEffect(() => {
    setModalInfo(fatigueZones[modalPage - 1]);
  }, [modalPage]);

  const handleRadioExams = useCallback((e: any) => {
    if (e.target.id === 'strength') {
      setModalPage(1)
      navigate('/players/keyMetrics/strength', { replace: true });
      setRadioExams({ strength: true, fatigue: false });
      setModalInfo(ArmRecovery);
    } else {
      setModalPage(5)
      navigate('/players/keyMetrics/fatigue', { replace: true });
      setRadioExams({ strength: false, fatigue: true });
      setModalInfo(ArmFatigue);
    }
  }, []);

  const manageModalPage = useCallback((direction) => {
    direction === 'up' ? setModalPage(modalPage + 1) : setModalPage(modalPage - 1);
  }, [modalPage]);

  const updateVelocity = useCallback(async (playerId, velocity) => {
    let response = await TEAMS.UpdateVelocity(playerId, velocity);
    return response;
  }, [TEAMS]);

  function SetModalBottom(info) {
    let rows = Object.entries(info.info.zones);
    return (
      <ModalBottom>
        <ModalBottomLabels>
          {rows.map((row, rowIndex) => (
            <React.Fragment key={rowIndex}>
              <Oval size={'8'} color={row[0]} margin={'0px 8px'} />
              {capitalizeFirstLetters(row[0], ' ')}
            </React.Fragment>
          ))}
        </ModalBottomLabels>
        <TableUnit color="black">
          <TableHead>
            <TableRow>
              <TableTopHeader hide={true}></TableTopHeader>
              <TableTopHeader colSpan={5} color="black">
                {String(info.info.title).toUpperCase()}
              </TableTopHeader>
            </TableRow>
            {info.info.categories && (
              <TableRow>
                <TableSubHeader hide={true} border={'none'}></TableSubHeader>
                {info.info.categories.map(category => (
                  <TableSubHeader key={category}>{category}</TableSubHeader>
                ))}
              </TableRow>
            )}
          </TableHead>
          <TableBody>
            {rows.map((row, rowIndex) => (
              <TableRow key={rowIndex} bgColor={row[0]}>
                <TableColumn width={'0px'}>
                  <Oval size={'8'} color={row[0]} margin={'0px 8px'} />
                </TableColumn>
                {Object.values(Object(row[1])).map((col, colIndex) => (
                  <TableColumn key={colIndex}>{String(col)}</TableColumn>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </TableUnit>
        {radioExams.strength && (
          <ModalDots>
            <Dot active={modalPage === 1} />
            <Dot active={modalPage === 2} />
            <Dot active={modalPage === 3} />
            <Dot active={modalPage === 4} />
          </ModalDots>
        )}
      </ModalBottom>
    );
  }

  const strengthTable = useMemo(() => (
    delayedLoadingStrength ? (
      <Loader height="90px" />
    ) : (
      <TableKeyMetrics
        dataTableContent={keyMetricsStrength}
        updateVelocity={updateVelocity}
        filter={playerNameSearch}
        onSort={handleSort}
        sortBy={sortBy}
        sortOrder={sortOrder}
      />
    )
  ), [delayedLoadingStrength, keyMetricsStrength, playerNameSearch, handleSort, sortBy, sortOrder, updateVelocity]);

  const fatigueTable = useMemo(() => (
    delayedLoadingFatigue ? (
      <Loader height="90px" />
    ) : (
      <TableKeyMetricsFatigue
        filter={playerNameSearch}
        dataTableContent={keyMetricsFatigue}
        onSort={handleSort}
        sortBy={sortBy}
        sortOrder={sortOrder}
      />
    )
  ), [delayedLoadingFatigue, keyMetricsFatigue, playerNameSearch, handleSort, sortBy, sortOrder]);

  const strengthPagination = useMemo(() => (
    !delayedLoadingStrength && (
      <PaginationControls
        totalItems={paginationStrength.totalItems}
        currentPage={paginationStrength.currentPage}
        recordsPerPage={paginationStrength.recordsPerPage}
        onPageChange={(page) => updatePaginationStrength(page, paginationStrength.recordsPerPage)}
        onLimitChange={(limit) => updatePaginationStrength(1, limit)}
        totalPages={paginationStrength.totalPages}
      />
    )
  ), [delayedLoadingStrength, paginationStrength, updatePaginationStrength]);

  const fatiguePagination = useMemo(() => (
    !delayedLoadingFatigue && (
      <PaginationControls
        totalItems={paginationFatigue.totalItems}
        currentPage={paginationFatigue.currentPage}
        recordsPerPage={paginationFatigue.recordsPerPage}
        onPageChange={(page) => updatePaginationFatigue(page, paginationFatigue.recordsPerPage)}
        onLimitChange={(limit) => updatePaginationFatigue(1, limit)}
        totalPages={paginationFatigue.totalPages}
      />
    )
  ), [delayedLoadingFatigue, paginationFatigue, updatePaginationFatigue]);

  return (
    <FluidContainer overflow={true} data-cy="keymetrics">
      <RadiosWrapper>
        <ExamRadios>
          <RadiosContainer onClick={handleRadioExams} mBottom={'15px'}>
            <Radio
              theme="button"
              title="STRENGTH & RECOVERY"
              name="radioExams"
              id="strength"
              checked={radioExams.strength}
              dynamicActive={radioExams.strength}
              size={'16px'}
            />

            <Radio
              theme="button"
              title="FATIGUE"
              name="radioExams"
              id="fatigue"
              checked={radioExams.fatigue}
              dynamicActive={radioExams.fatigue}
              size={'16px'}
            />
          </RadiosContainer>
        </ExamRadios>
        <ExamInfoContainer>
          <ArmRecoveryContainer>
            <>
              <ArmRecoveryTop>
                {radioExams.strength ? <TextContainer>KEY SCALE</TextContainer> : <TextContainer>ARM FATIGUE</TextContainer>}
                {<ArmRecoveryInfoButton onClick={() => setKeyScaleModal(true)}>i</ArmRecoveryInfoButton>}
              </ArmRecoveryTop>
              <AlertWrapper>
                <AlertContainer>
                  <Oval size={'8'} color={'watch'} />
                  <span> Watch</span>
                </AlertContainer>
                <AlertContainer>
                  <Oval size={'8'} color={'warning'} />
                  <span> Warning</span>
                </AlertContainer>
                <AlertContainer>
                  {!radioExams.fatigue && (
                    <>
                      <Oval size={'8'} color={'medical'} />
                      <span> Medical</span>
                    </>
                  )}
                </AlertContainer>
              </AlertWrapper>
            </>
          </ArmRecoveryContainer>
        </ExamInfoContainer>
      </RadiosWrapper>
      <TableWrapper minHeight={'400px'}>
        {radioExams.strength && strengthTable}
        {radioExams.fatigue && fatigueTable}
        {keyScaleModal && (
          <Modal active={setKeyScaleModal} maxWidth={'640px'} width={'80vw'} padding={'0'} margin={'40px auto'} minWidth={'480px'}>
            <ModalTop>
              {radioExams.strength ? (
                <>
                  <ModalDivArrow onClick={() => manageModalPage('down')}>{modalPage !== 1 && '<'}</ModalDivArrow>
                  {modalPage === 1 && (
                    <ModalTopText>
                      <ModalH1>ARM STRENGTH</ModalH1>
                      Arm Strength is represented by the relative strength, a metric that is expressed as muscular force divided by body
                      weight. Relative strength is important for health. As the body grows, throwing arm strength must also increase to
                      improve resistance to strains and sprains. Optimal relative strength for internal rotation and external rotation is
                      <ModalSpan>{' 20% '}</ModalSpan>
                      of body weight, while scaption (strength in arm elevation) and grip strength should be at least
                      <ModalSpan>{' 15% '}</ModalSpan>
                      body weight. If you are low in these values, the app will trigger exercise prescriptions to make improvements.
                      <br></br>
                      <br></br>
                      Recommendations:
                      <ModalH1 marginBottom={'0px'}>WATCH</ModalH1>
                      Reduce throwing workloads while you increase strength and evaluate recovery habits.
                      <ModalH1 marginBottom={'0px'}>WARNING</ModalH1>
                      Skip an outing, bullpen and high intensity weighted ball programming while training is intensified to increase
                      strength.
                    </ModalTopText>
                  )}
                  {modalPage === 2 && (
                    <ModalTopText>
                      <ModalH1>SHOULDER BALANCE</ModalH1>
                      Shoulder Balance, also known as the ER:IR Ratio, compares the strength balance of the backside (external rotators)
                      compared to the frontside (internal rotators) of your throwing arm. The optimal range for ER:IR Ratio is between
                      <ModalSpan>{' 0.85 - 1.05'}</ModalSpan>. If your ratio is below <ModalSpan>{' 0.85 '}</ModalSpan>your external
                      rotators are weak compared to your internal rotators. If your ratio is above <ModalSpan>{' 1.05'}</ModalSpan>, your
                      internal rotators are weak compared to your external rotators. The wider the strength gap between the shoulder ER
                      and IR, the higher the risk of injury.
                      <br></br>
                      <br></br>
                      Recommendations:
                      <ModalH1 marginBottom={'0px'}>WATCH</ModalH1>
                      Reduce throwing workloads while you increase strength and evaluate recovery habits.
                      <ModalH1 marginBottom={'0px'}>WARNING</ModalH1>
                      Skip an outing, bullpen and high intensity weighted ball programming while training is intensified to increase
                      strength.
                    </ModalTopText>
                  )}
                  {modalPage === 3 && (
                    <ModalTopText>
                      <ModalH1>STRENGTH VELOCITY RATIO</ModalH1>
                      Research shows that an increase of<ModalSpan>{' 1 mph '}</ModalSpan>of velocity can increase elbow torque by
                      <ModalSpan>{' 1 unit'}</ModalSpan>. This means that as velocity improves, stress to the elbow can also increase.
                      To protect the elbow from injury, we have build in a metric that evaluates total arm strength relative to maximum velocity.
                      Our optimal measure is <ModalSpan>{' 1.6'}</ModalSpan> for athletes 15 and over and {' '}<ModalSpan>{' 1.3'}</ModalSpan>
                      {' '}for athletes under 15 years. If you are below, our training programs will be focused on raising total arm strength.
                      If you are above and your velocity is low, you may be eligible for velocity enhancement training.
                      <br></br>
                      <br></br>
                      Recommendations:
                      <ModalH1 marginBottom={'0px'}>WATCH</ModalH1>
                      Reduce throwing workloads while you increase strength and evaluate recovery habits.
                      <ModalH1 marginBottom={'0px'}>WARNING</ModalH1>
                      Skip an outing, bullpen and high intensity weighted ball programming while training is intensified to increase
                      strength.
                    </ModalTopText>
                  )}
                  {modalPage === 4 && (
                    <ModalTopText>
                      <ModalH1>ARM RECOVERY</ModalH1>A change in your weekly average Fresh exam indicates your throwing arm recovery.
                      Total arm strength decreases need to be less than 10 lbs and less than 5 lbs from average for each individual
                      muscle. If total strength decreases 10 lbs or more or 5 lbs or more for each muscle group, you are showing signs
                      that your recovery is less than optimal. Reducing pitch counts, pushing bullpens back and lower throwing intensity
                      can help improve recovery.
                      <br></br>
                      <br></br>
                      Recommendations:
                      <ModalH1 marginBottom={'0px'}>WATCH</ModalH1>
                      Reduce throwing workloads while you increase strength and evaluate recovery habits.
                      <ModalH1 marginBottom={'0px'}>WARNING</ModalH1>
                      Skip an outing, bullpen and high intensity weighted ball programming while training is intensified to increase
                      strength.
                      <ModalH1 marginBottom={'0px'}>MEDICAL</ModalH1>
                      Seek evaluation by a licensed medical professional.
                    </ModalTopText>
                  )}
                  <ModalDivArrow onClick={() => manageModalPage('up')}>{modalPage !== 4 && '>'}</ModalDivArrow>
                </>
              ) : (
                <>
                  <ModalTopText>
                    <ModalH1>ARM FATIGUE</ModalH1>
                    Arm Fatigue is determined by strength evaluations after high intensity throwing days to understand how fatigued your
                    throwing arm becomes after games, bullpens, and velocity training days. The goal is to retain more than 90% of your
                    strength from Fresh Exams (%Fresh). If you cannot retain 90% of your Fresh strength, you may need to lower your
                    workload and spend more time building strength and endurance.
                    <br></br>
                    <br></br>
                    Recommendations:
                    <ModalH1 marginBottom={'0px'}>WATCH</ModalH1>
                    Reduce throwing workloads for your next high intensity throwing day. For example if strength was not retained on the
                    game day, lower pitch counts on your next bullpen/game day/velo day, but maintain strength training.
                    <ModalH1 marginBottom={'0px'}>WARNING</ModalH1>
                    Reduce throwing workloads for your next high intensity throwing day. In addition to making adjustments to your next
                    high intensity throwing day, you need to focus on recovery habits and strength. It is a good idea after a Warning to
                    make the next day a low intensity throwing day or a complete day of rest.
                  </ModalTopText>
                </>
              )}
            </ModalTop>
            <SetModalBottom info={modalInfo}/>
          </Modal>
        )}
      </TableWrapper>
      {radioExams.strength && !delayedLoadingStrength && strengthPagination}
      {radioExams.fatigue && !delayedLoadingFatigue && fatiguePagination}
    </FluidContainer>
  );
}
export default KeyMetrics
